import IconChevron from "@Icons/chevrons/IconChevron";
import React from "react";
import {RotationOrientationType} from "@Features/icons/types/RotationOrientationType";

interface ExpandReviewButtonProps {
    isInactive: boolean,
    direction: RotationOrientationType
}

function ExpandReviewButton({isInactive, direction}: ExpandReviewButtonProps) {
    return (
        <div className={`gb--review-icon-container ${isInactive ? "gb--review-icon-container-disabled" : ""}`}>
            <IconChevron
                chevronOrientation={direction}
                width="24"
                height="24"
                fill={isInactive ? "#9b9b9b" : "#000000"}
            />
        </div>
    )
}

export default ExpandReviewButton;